export const SCREENING_ALLOWED_VALUES = {
  ALLOWED: 'allowed',
  NOT_ALLOWED: 'notAllowed',
  STRICT_NOT_ALLOWED: 'strictNotAllowed',
};
